import actionTypes from 'SRC/modules/redux/actionTypes'

export const setFormLoading = isLoading => ({
  type: actionTypes.SET_FORM_LOADING,
  payload: isLoading
})
